module.exports = __webpack_public_path__ + "static/media/1_pl.ed517c15.png";